import axios from "axios";

export default class axiosClient {
  async getStakingPoolsEarned() {
    const resp = await axios.get("api/token_events/get_my_staking_pools_earned");
    return resp.data;
  }

  async getAllAuCapitals(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    let url = "api/au_capitals";
    if (params?.description) {
      url = "api/au_capitals/search";
    }
    const resp = await axios.get(url, { headers, params });
    const data = resp.data["hydra:member"];
    const totalItems = resp.data["hydra:totalItems"];
    return { data, totalItems };
  }

  async getInvestmentsAuCapitals(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    try {
      const resp = await axios.get("api/au_capitals/my_investments", { headers, params });
      const data = resp.data["hydra:member"];
      const totalItems = resp.data["hydra:totalItems"];
      return { data, totalItems };
    }
    catch (error) {
      console.log(error);
    }
  }

  async getInvestments() {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    try {
      const resp = await axios.get("api/au_capitals/my_investments", {
        headers, params: {
          investDateFrom: "01.01." + new Date().getFullYear()
        }
      });
      return resp.data["hydra:member"];
    }
    catch (error) {
      console.log(error);
    }
  }

  async getInvestmentsNoPagination(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    try {
      const resp = await axios.get("api/au_capitals/my_investments", { headers, params });
      const data = resp.data["hydra:member"];
      const totalItems = resp.data["hydra:totalItems"];
      return { data, totalItems };
    }
    catch (error) {
      console.log(error);
    }
  }

  async getAuCapitals(id) {
    if (!id || id == 0) {
      return [];
    }

    try {
      const resp = await axios.get(`api/au_capitals/${id}`);
      return resp.data;
    }
    catch (error) {
      console.log(error);
    }
  }

  async getPortfolioTracker(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    try {
      const resp = await axios.get("api/capital_metrics", {
        headers: headers,
        params: params
      });
      const data = resp.data["hydra:member"];
      const totalItems = resp.data["hydra:totalItems"];
      return { data, totalItems };
    }
    catch (error) {
      console.log(error);
    }
  }

  async getPortfolioTrackerId(id) {
    try {
      const resp = await axios.get(`api/capital_metrics/${id}`);
      return resp.data;
    }
    catch (error) {
      console.log(error);
    }
  }

  async putPortfolioTracker(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    try {
      return await axios.post("api/capital_metrics", params, headers);
    }
    catch (error) {
      throw new Error(error);
    }
  }

  async patchPortfolioTracker(id, body) {
    const headers = {
      "Content-Type": "application/merge-patch+json"
    };
    try {
      return await axios.patch(`api/capital_metrics/${id}`, body, { headers });
    }
    catch (error) {
      throw new Error(error);
    }
  }

  async getAuCapitalsByParams(data) {
    const params = {
      page: 1,
      itemsPerPage: 3,
      ...data
    };

    const resp = await axios.get("api/au_capitals", { params });
    return resp.data;
  }

  async getAuCapitalsParams(param) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    const params = {
      page: 1,
      ...param
    };
    const resp = await axios.get("api/au_capitals", {
      headers: headers,
      params: params
    });
    const data = resp.data["hydra:member"];
    const totalItems = resp.data["hydra:totalItems"];
    return { data, totalItems };
  }

  async getCapitalInvestor(params) {
    const headers = {
      accept: "application/ld+json",
      "Content-Type": "application/ld+json"
    };
    const resp = await axios.get("api/au_capital_investors/get", {
      headers: headers,
      params: params
    });
    const data = resp.data["hydra:member"];
    const totalItems = resp.data["hydra:totalItems"];
    return { data, totalItems };
  }

  async setFollowing(id) {
    const body = {
      auCapital: id
    };
    const resp = await axios.post("/api/following_capitals/start", body);
    return resp.data;
  }

  async getPayDividends(id) {
    try {
      const resp = await axios.get(`api/au_capitals/close_foundation_capital/${id}`);
      return resp?.data;
    }
    catch (error) {
      console.log(error);
      if (error?.response?.status != "500") {
        return { error: error?.response?.data?.message || error?.response?.data?.error };
      }
      else {
        throw new Error(error);
      }
    }
  }

  async unsetFollowing(id) {
    const body = {
      auCapital: id
    };
    const resp = await axios.post("/api/following_capitals/stop", body);
    return resp.data;
  }

  async getFollowings() {
    const params = {
      page: 1,
      itemsPerPage: 30,
      pagination: false
    };
    const resp = await axios.get("api/following_capitals", { params });
    return resp.data;
  }

  async getReferralInvestment(tokenId) {
    const params = {
      tokenId: tokenId
    };
    const resp = await axios.get("/api/au_capitals/referrals_investments", {
      params
    });
    return resp.data;
  }

  async downloadMemorandum(url, name, sum) {
    const response = await axios({
      url: url + (sum ? `/${sum}` : ""),
      method: "GET",
      responseType: "blob"
    });

    const href = URL.createObjectURL(response.data);

    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
  }

  async cancelInvestment(iri) {
    const body = {
      auCapital: iri
    };
    const resp = await axios.post("/api/token_events/create/cancel_investment", body);
    return resp.data;
  }
}